export default __webpack_public_path__ + "media/images/paylogos/color/electron@2x-6a94606282dfed5fe2f22f68e5ba0f2b.png";